import { render } from "./FooterSection.vue?vue&type=template&id=1c2c8a73&scoped=true"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import "./FooterSection.vue?vue&type=style&index=0&id=1c2c8a73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2c8a73"]])

export default __exports__